export default __webpack_public_path__ + "static/media/transfer-network-confirmation-pass.92291bbb.svg";